import gql from "graphql-tag";

export const importWizard = gql`
  mutation importWizard($input: ImportWizardInput) {
    importWizard(input: $input) {
      success
      message
      idImportSchema
    }
  }
`;
export const getImportSchemas = gql`
  query getImportSchemas($idPrograma: Int!) {
    getImportSchemas(idPrograma: $idPrograma) {
      idImportSchema
      json
      fechaCreacion
      allowDuplicatedEmails
      otherOptions
    }
  }
`;

export default {
  mutations: { importWizard },
  queries: { getImportSchemas }
};
